module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAABaCAIAAAADwCBaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wgUBjIrhfZe0AAAAJxJREFUSMftlkEKwCAMBLshH/D/v/QD9qCkaSqNBauXeBCRye4mSClSSoe3GIAL0TGwNii5HBM1rpRS6XqQ/WZnDnq3mWqpVgLAxr6r1zJNGMEYREQ1rOSVKJKdzTCfZwATg/88AmnTCa6L2fQsAvrSKnXdF3SnH+CbndRveHQr7dw5OUrXnFw7APO+dAEFFFBAAQUU0Kefh5yzC52pZDHFHUiQyAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/windjammer_bg.png
// module id = 2479
// module chunks = 7